import React from "react";
import Card from "react-bootstrap/Card";
import { AiOutlineCheckCircle } from "react-icons/ai";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
              Hi everyone, I’m <span className="purple">Chenyu Wu</span>.
              <br />
              I’m based in <span className="purple">London, UK</span>.
              <br />
              I hold a Master of Research from <span className="purple">Imperial College London</span>, where I developed a strong foundation in analytical thinking and computational methods.
              <br />
              <br />
              I am a <span className="purple">Data Engineer</span> with a background in software engineering and applied data science.
              My work focuses on building cloud-based data pipelines, ETL workflows and reliable data systems using Python, SQL and AWS technologies.
              <br />
              <br />
              I also have experience working with machine learning and LLM-driven systems, which allows me to design data pipelines that effectively support analytics and AI-driven applications.
              <br />
              <br />
              Outside of tech, I enjoy hiking, mountaineering, rock climbing, bikepacking and skiing.
            </p>

          <ul>
            <li className="about-activity">
              <AiOutlineCheckCircle /> Hiking / Mountaineering
            </li>
            <li className="about-activity">
              <AiOutlineCheckCircle /> Rock Climbing / Skiing
            </li>
            <li className="about-activity">
              <AiOutlineCheckCircle /> Bikepacking
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Chenyu Wu</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;

